import { render, staticRenderFns } from "./title-duanluo.vue?vue&type=template&id=904b65f2&scoped=true&"
import script from "./title-duanluo.vue?vue&type=script&lang=ts&"
export * from "./title-duanluo.vue?vue&type=script&lang=ts&"
import style0 from "./title-duanluo.vue?vue&type=style&index=0&id=904b65f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904b65f2",
  null
  
)

export default component.exports